import { app } from '../../../../bootstrap/core';
import { standingOrdersState } from './standingOrders.state';
import { standingOrdersComponent } from './standingOrders.component';

import './conflictModal/conflictModal';

app.config(standingOrdersState);
app.component(standingOrdersComponent.name, standingOrdersComponent);
